let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gR1Yg")).then(() => parcelRequire('ld96b'));